import { getRolePreview } from "../../../shared/api/client";
import { purchaseOrderScopeKey } from "./purchase-order-scope-key";
import type { PurchaseOrdersProps as Props } from "./purchase-order-workspace-types";
import { usePurchaseOrdersWorkspace } from "./usePurchaseOrdersWorkspace";
import { PurchaseOrdersHeader } from "./PurchaseOrdersHeader";
import { PurchaseOrdersManagement } from "./PurchaseOrdersManagement";
import { PurchaseOrdersOperations } from "./PurchaseOrdersOperations";
import { PurchaseOrdersList } from "./PurchaseOrdersList";
import { PurchaseOrderDialog } from "./PurchaseOrderDialog";

export function PurchaseOrdersModule(props: Props) {
  const previewKey = getRolePreview();
  return <PurchaseOrdersWorkspace key={purchaseOrderScopeKey(props.user, previewKey)} {...props} previewKey={previewKey} />;
}
function PurchaseOrdersWorkspace(props: Props & { previewKey: string | null; }) {
  const workspace = usePurchaseOrdersWorkspace(props);
  return (<>
    <PurchaseOrdersHeader
      createdOrder={workspace.createdOrder}
      initialRequestNo={workspace.initialRequestNo}
      onReturnToOffers={workspace.onReturnToOffers}
      expanded={workspace.expanded}
      setFilter={workspace.setFilter}
      setExpanded={workspace.setExpanded}
      setFocusedOrderId={workspace.setFocusedOrderId}
      recordedDeliveryOrder={workspace.recordedDeliveryOrder}
      setRecordedDeliveryOrder={workspace.setRecordedDeliveryOrder}
    />
    <PurchaseOrdersManagement management={workspace.management} />
    <PurchaseOrdersOperations
      filter={workspace.filter}
      setFilter={workspace.setFilter}
      isQuality={workspace.isQuality}
      dataLoaded={workspace.dataLoaded}
      metrics={workspace.metrics}
      isSpecialist={workspace.isSpecialist}
      candidates={workspace.candidates}
      setOperationError={workspace.setOperationError}
      setDialog={workspace.setDialog}
    />
    <PurchaseOrdersList
      isPlanning={workspace.isPlanning}
      loading={workspace.loading}
      loadError={workspace.loadError}
      load={workspace.load}
      visible={workspace.visible}
      filter={workspace.filter}
      isSpecialist={workspace.isSpecialist}
      candidates={workspace.candidates}
      expanded={workspace.expanded}
      focusedOrderId={workspace.focusedOrderId}
      setExpanded={workspace.setExpanded}
      isQuality={workspace.isQuality}
      setQualityStatus={workspace.setQualityStatus}
      setQualityNote={workspace.setQualityNote}
      setQualityDisposition={workspace.setQualityDisposition}
      setOperationError={workspace.setOperationError}
      setDialog={workspace.setDialog}
      documentUrl={workspace.documentUrl}
      submitting={workspace.submitting}
      setDispatchRecipient={workspace.setDispatchRecipient}
      setDeliveryAddress={workspace.setDeliveryAddress}
      openReceipt={workspace.openReceipt}
      setNote={workspace.setNote}
    />
    <PurchaseOrderDialog
      dialog={workspace.dialog}
      submitting={workspace.submitting}
      setDialog={workspace.setDialog}
      operationError={workspace.operationError}
      isRolePreview={workspace.isRolePreview}
      dispatchRecipient={workspace.dispatchRecipient}
      deliveryAddress={workspace.deliveryAddress}
      setDeliveryAddress={workspace.setDeliveryAddress}
      expectedQuantity={workspace.expectedQuantity}
      setExpectedQuantity={workspace.setExpectedQuantity}
      quantity={workspace.quantity}
      setQuantity={workspace.setQuantity}
      returnQuantity={workspace.returnQuantity}
      setReturnQuantity={workspace.setReturnQuantity}
      deliveredAt={workspace.deliveredAt}
      setDeliveredAt={workspace.setDeliveredAt}
      deliveryNoteNo={workspace.deliveryNoteNo}
      setDeliveryNoteNo={workspace.setDeliveryNoteNo}
      returnDisposition={workspace.returnDisposition}
      setReturnDisposition={workspace.setReturnDisposition}
      returnReason={workspace.returnReason}
      setReturnReason={workspace.setReturnReason}
      deliveryDocument={workspace.deliveryDocument}
      chooseDeliveryDocument={workspace.chooseDeliveryDocument}
      setDeliveryDocument={workspace.setDeliveryDocument}
      note={workspace.note}
      setNote={workspace.setNote}
      qualityStatus={workspace.qualityStatus}
      setQualityStatus={workspace.setQualityStatus}
      qualityNote={workspace.qualityNote}
      setQualityNote={workspace.setQualityNote}
      qualityDisposition={workspace.qualityDisposition}
      setQualityDisposition={workspace.setQualityDisposition}
      canSubmit={workspace.canSubmit}
      submit={workspace.submit}
    />
  </>);
}
